import { useMemo, cloneElement } from 'react';
import { Space } from 'antd';
import PageSection from '../page-section';
import Image from '../image';

import Breadcrumb from '../breadcrumb';
import { Heading, Subtitle, Text } from '../typography';
import Button from '../button';
import { faFlag } from '@fortawesome/free-solid-svg-icons';

/**
 * Image: ImageObject {data:{}, src:"", alt:"", style:{}, format}
 * title: String
 * subtitle: String | String[]
 * Metadata: String | String[]
 * Links: <Link />[]
 */
function PageHeader({ title, subtitle, metadata, links, image = {}, type = "hero", style, reportIssue }) {
  const imageStyle = useMemo(() => {
    if (image !== null && typeof image === "object" && image.style) {
      return image.style;
    }
  }, [image]);

  const subtitles = subtitle && !Array.isArray(subtitle) ? [subtitle] : subtitle;
  metadata = metadata && !Array.isArray(metadata) ? [metadata] : metadata;

  return (
    <PageSection className="page-header" padding="horizontal" type={type} style={style}>
      <Breadcrumb style={{ paddingBottom: "2em", width: "100%" }} />
      <Image
        {...image}
        className="in-large-page"
        rounded
        bordered
        style={{
          objectFit: "cover",
          objectPosition: "center top",
          marginRight: "2em",
          minHeight: "175px",
          float: "left",
          ...imageStyle
        }}
      />
      <Heading level={1} style={{ marginBottom: "0em" }} >{title}</Heading>
      <div style={{ paddingTop: "0.5em" }} >
        {subtitle &&
          <Space split="|" size={12} wrap>{subtitles.filter(s => !!s).map((s, i) => <Subtitle key={i}>{s}</Subtitle>)}</Space>
        }

        {metadata &&
          <div style={{ paddingTop: "0.5em" }} >
            <Space split="|" size={12} wrap>{metadata.map((d, i) => <Text key={i}>{d}</Text>)}</Space>
          </div>
        }
      </div>
      <Image
        {...image}
        className="in-small-page"
        rounded
        bordered
        style={{
          objectFit: "cover",
          objectPosition: "center top",
          marginTop: "1em",
          maxHeight: "20em",
        }}
      />
      {links &&
        <Space size={14} className="bccampus-item-group" wrap style={{ paddingTop: "1em" }}>
          {links.filter(l => !!l).map((link, i) => cloneElement(link, { key: i, style: { width: "100%" } }))}
        </Space>
      }
      {reportIssue &&
        <div style={{ paddingTop: "1em", textAlign: "right" }}>
          <Button type="text" icon={faFlag} onClick={reportIssue}>Report Issue</Button>
        </div>
      }
    </PageSection >
  )
}

export default PageHeader;
